export const BundleCodes = {
  PACK_SMART: "BND1",
  PACK_FULL: "BND2",
  DISCOUNTED_PACKS_MART: "BNC1",
  DISCOUNTED_PACK_FULL: "BNC2",
} as const;

export const FLIGHT_BUNDLES = {
  BASIC: [
    "BND0", // Normal
    "AAL0", // Redemption
    "BNC0", // Discount Club
    "BCC0", // ChileCompra Normal
    "BPC0", // PeruCompra Normal
    "BNB0", // BancoEstado Normal
    "BEC0", // BancoEstado Discount Club
  ],

  ESSENTIAL: [
    "WWW1", // Normal
    "AAL1", // Redemption
    "WDC1", // Discount Club
    "BCC1", // ChileCompra Normal
    "BNC1", // ChileCompra/PeruCompra Discount Club
    "BPC1", // PeruCompra Normal
    "BNB1", // BancoEstado Normal
    "BEC1", // BancoEstado Discount Club
  ],

  SMART: [
    "WWW2", // Normal
    "AAL2", // Redemption
    "WDC2", // Discount Club
    "BCC2", // ChileCompra Normal
    "BNC2", // ChileCompra/PeruCompra Discount Club
    "BPC2", // PeruCompra Normal
    "BNB2", // BancoEstado Normal
    "BEC2", // BancoEstado Discount Club
  ],

  FULL_FLEX: [
    "WWW3", // Normal / Redemption / ChileCompra / PeruCompra
    "WDC3", // Discount Club
  ],
} as const;

const isBundleType = (
  bundleCode: string | null | undefined,
  bundleCodes: readonly string[],
): boolean => {
  return bundleCodes.some((code) => code === bundleCode?.toUpperCase());
};

export const isBasicBundle = (bundleCode: string | null | undefined): boolean => {
  return isBundleType(bundleCode, FLIGHT_BUNDLES.BASIC);
};

export const isLightBundle = (bundleCode: string | null | undefined): boolean => {
  return isBundleType(bundleCode, FLIGHT_BUNDLES.ESSENTIAL);
};

export const isSmartBundle = (bundleCode: string | null | undefined): boolean => {
  return isBundleType(bundleCode, FLIGHT_BUNDLES.SMART);
};

export const isFullFlexBundle = (bundleCode: string | null | undefined): boolean => {
  return isBundleType(bundleCode, FLIGHT_BUNDLES.FULL_FLEX);
};

export const isSmartOrFullFlexBundle = (bundleCode: string | null | undefined): boolean => {
  return isSmartBundle(bundleCode) || isFullFlexBundle(bundleCode);
};
